import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { borderRadii } from 'app/spacing';

const Container = styled.div`
  border: 1px solid var(--color-border-medium);
  border-top-width: 0;
  border-right-width: 0;
  height: 42px;
  display: flex;
  justify-content: center;
  align-items: center;

  ${({ isFirstRow }) =>
    isFirstRow &&
    css`
      border-top-right-radius: ${borderRadii.small};
    `}
  ${({ isLastRow }) =>
    isLastRow &&
    css`
      border-bottom-right-radius: ${borderRadii.small};
      border-bottom-width: 0;
    `}
`;

const DayCalendarCell = ({ children, ...rest }) => {
  return <Container {...rest}>{children}</Container>;
};

export default DayCalendarCell;
